import { Box } from "@mui/material";
import { isAndroidPlatform } from "@src/appV2/lib";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import blackPixelImage from "public/assets/images/black-pixel.png";
import { useCallback, useEffect, useState } from "react";

interface VideoCommentPlayerProps {
  url: string;
  workplaceId: string;
  commentId: string;
}

export function VideoCommentPlayer(props: VideoCommentPlayerProps) {
  const { url, workplaceId, commentId } = props;
  const [videoRef, setVideoRef] = useState<HTMLVideoElement>();
  const isAndroid = isAndroidPlatform();

  const handleRef = useCallback((ref: HTMLVideoElement | null) => {
    setVideoRef(ref ?? undefined);
  }, []);

  useEffect(() => {
    videoRef?.load();
  }, [videoRef]);

  return (
    <Box
      sx={{
        "& video": {
          background: (theme) => theme.palette.common.black,
          width: "100%",
          maxHeight: "300px",
          display: "block",
          aspectRatio: "16 / 9",
          objectFit: "contain",
          borderRadius: (theme) => theme.shape.borderRadius,
        },
      }}
    >
      <video
        ref={handleRef}
        controls
        playsInline
        disablePictureInPicture
        disableRemotePlayback
        preload="metadata"
        src={isAndroid ? `${url}#t=0.1` : url}
        poster={isAndroid ? blackPixelImage : undefined}
        onPlay={() => {
          logEvent(APP_V2_USER_EVENTS.WORKPLACE_REVIEWS_VIDEO_PLAYED, {
            workplaceId,
            commentId,
          });
        }}
        onEnded={() => {
          logEvent(APP_V2_USER_EVENTS.WORKPLACE_REVIEWS_VIDEO_COMPLETED, {
            workplaceId,
            commentId,
          });
        }}
        onLoadedData={(event) => {
          if (event.currentTarget.hasAttribute("poster")) {
            event.currentTarget.removeAttribute("poster");
          }
        }}
      />
    </Box>
  );
}
